import { render, staticRenderFns } from "./Date.vue?vue&type=template&id=faf5bd54&"
import script from "./Date.vue?vue&type=script&lang=js&"
export * from "./Date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faf5bd54')) {
      api.createRecord('faf5bd54', component.options)
    } else {
      api.reload('faf5bd54', component.options)
    }
    module.hot.accept("./Date.vue?vue&type=template&id=faf5bd54&", function () {
      api.rerender('faf5bd54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/Common/Forms/Date.vue"
export default component.exports